export default __webpack_public_path__ + "static/media/call-to-action.654032bb.png";